import {Component} from 'react';


class MoneyMgmtTopicCard extends Component {
  constructor(props) {
    super(props);
    this.state={
      cardNbr: 0
    }   
}
 
render() {
     if (+this.props.questionInfo.nbrQuestions === 0){
          this.pctCorrect = 0
     }else{
          this.pctCorrect = ((+this.props.questionInfo.nbrCorrect / 
               +this.props.questionInfo.nbrQuestions)* 100).toFixed(0);  
     }
     this.topicClass = "text-left";
     if (this.props.questionInfo.topic === "Test Totals"){
          this.topicClass += " font-weight-bold";
     }
       
return <>
      <tr>
            <td className={this.topicClass}>
                 {this.props.questionInfo.topic}
            </td>
            <td className="text-center" >
                 {this.props.questionInfo.nbrQuestions}
            </td>
            <td className="text-center" >
                 {this.props.questionInfo.nbrCorrect}
            </td>     
            <td className="text-center" >
                 {this.pctCorrect}%
            </td>  
             <td className="text-center" >
                 {this.props.questionInfo.partialCorrect}
            </td>             
      </tr>         
           
   </>
  }
}

export default MoneyMgmtTopicCard;